// (function () {
//   if (window.__pgScriptInitialized) return;
//   window.__pgScriptInitialized = true;

//   // ── Price Table ──────────────────────────────────────────────
//   const PRICE_TABLE = {
//     1: 19.99, 2: 18.99, 3: 18.04, 4: 17.14, 5: 16.28,
//     6: 15.47, 7: 14.69, 8: 13.96, 9: 13.26, 10: 11.94,
//     11: 11.34, 12: 10.77, 13: 10.23, 14: 9.72, 15: 9.24,
//     16: 8.77, 17: 8.34, 18: 7.92, 19: 7.52, 20: 6.99
//   };
//   const BASE_PRICE    = PRICE_TABLE[1];
//   const MAX_PRICE_QTY = 20;  // price table-e shorboccho tier eita
//   const MAX_QTY       = 49;  // overall max quantity (slider max er sathe match)

//   function getUnitPrice(qty) {
//     // 20 er upore gele 20 er price-i thakbe
//     return PRICE_TABLE[Math.min(qty, MAX_PRICE_QTY)];
//   }

//   function fmt(n) {
//     return '$' + n.toFixed(2);
//   }

//   function getSavePercent(qty) {
//     return (((BASE_PRICE - getUnitPrice(qty)) / BASE_PRICE) * 100).toFixed(2);
//   }

//   // ── DOM refs ─────────────────────────────────────────────────
//   const qtyInput       = document.getElementById('qty-input');
//   const qtySlider      = document.querySelector('.quantity-control__slider');
//   const qtyHidden      = document.getElementById('pg-qty-hidden');
//   const unitPriceEl    = document.getElementById('pgUnitPrice');
//   const totalPriceEl   = document.getElementById('pgTotalPrice');
//   const comparePriceEl = document.getElementById('pgComparePrice');
//   const qsButtons      = document.querySelectorAll('.quickselect__option:not(.quickselect__option--contact)');

//   let currentQty = 1;

//   // ── Slider fill ──────────────────────────────────────────────
//   function updateSliderFill() {
//     if (!qtySlider) return;
//     const min     = parseInt(qtySlider.min, 10);
//     const max     = parseInt(qtySlider.max, 10);
//     const val     = parseInt(qtySlider.value, 10);
//     const percent = ((val - min) / (max - min)) * 100;
//     qtySlider.style.background =
//       'linear-gradient(to right, #ddcb9f 0%, #ddcb9f ' + percent + '%, #f9f5ef ' + percent + '%, #f9f5ef 100%)';
//   }

//   // ── Update price UI ──────────────────────────────────────────
//   function updatePriceUI(qty) {
//     currentQty = Math.max(1, Math.min(MAX_QTY, parseInt(qty) || 1));

//     if (qtyInput)  qtyInput.value  = currentQty;
//     if (qtyHidden) qtyHidden.value = currentQty;

//     if (qtySlider) {
//       qtySlider.value = currentQty;
//       updateSliderFill();
//     }

//     const unit         = getUnitPrice(currentQty);
//     const total        = unit * currentQty;
//     const compareTotal = BASE_PRICE * currentQty;

//     // main price box ekhon TOTAL dekhabe (unit na)
//     if (unitPriceEl)  unitPriceEl.textContent  = fmt(total);

//     // optional separate total element (jodi thake)
//     if (totalPriceEl) totalPriceEl.textContent = fmt(total);

//     // compare price (strikethrough original total)
//     if (comparePriceEl) {
//       if (compareTotal > total) {
//         comparePriceEl.textContent   = fmt(compareTotal);
//         comparePriceEl.style.display = '';
//       } else {
//         comparePriceEl.style.display = 'none';
//       }
//     }

//     // quick select active
//     qsButtons.forEach(btn => {
//       btn.classList.toggle(
//         'quickselect__option--active',
//         parseInt(btn.dataset.qty) === currentQty
//       );
//     });
//   }

//   // ── Quick select labels ──────────────────────────────────────
//   function initQuickSelectLabels() {
//     [5, 10, 20].forEach(qty => {
//       const el = document.getElementById('save-' + qty);
//       if (el) el.textContent = getSavePercent(qty) + '% Save';
//     });
//   }

//   // ── Quantity events ──────────────────────────────────────────
//   const minusBtn = document.querySelector('.quantity-control__btn--minus');
//   const plusBtn  = document.querySelector('.quantity-control__btn--plus');

//   if (minusBtn) minusBtn.addEventListener('click', () => updatePriceUI(currentQty - 1));
//   if (plusBtn)  plusBtn.addEventListener('click',  () => updatePriceUI(currentQty + 1));

//   if (qtyInput) {
//     qtyInput.addEventListener('input', function () {
//       updatePriceUI(this.value);
//     });
//   }

//   if (qtySlider) {
//     qtySlider.addEventListener('input', function () {
//       updatePriceUI(this.value);
//     });
//   }

//   // ── Quick select events ──────────────────────────────────────
//   qsButtons.forEach(btn => {
//     btn.addEventListener('click', function () {
//       updatePriceUI(parseInt(this.dataset.qty));
//     });
//   });

//   const contactBtn = document.querySelector('.quickselect__option--contact');
//   if (contactBtn) {
//     contactBtn.addEventListener('click', function () {
//       window.location.href = '/pages/contact';
//     });
//   }

//   // ── Cart Drawer price sync ───────────────────────────────────
//   function initCartDrawerPriceSync() {
//     // Shopify standard cart:updated event
//     document.addEventListener('cart:updated', function (e) {
//       if (!e.detail || !e.detail.cart) return;
//       const items = e.detail.cart.items;
//       if (items && items.length > 0) {
//         updatePriceUI(items[0].quantity);
//       }
//     });

//     // cart drawer quantity input direct watch
//     document.addEventListener('change', function (e) {
//       const target = e.target;
//       if (
//         target.closest('cart-drawer-component') &&
//         (target.name === 'updates[]' || target.type === 'number')
//       ) {
//         updatePriceUI(parseInt(target.value) || 1);
//       }
//     });
//   }

//   // ── Add to Cart — Ajax ───────────────────────────────────────
//   const form = document.getElementById('pg-product-form');
//   if (form) {
//     form.addEventListener('submit', function (e) {
//       e.preventDefault();

//       const variantId = document.getElementById('pg-variant-id').value;
//       const qty       = currentQty;
//       const cartBtn   = form.querySelector('.add-to-cart');

//       if (cartBtn) {
//         cartBtn.disabled = true;
//         cartBtn.classList.add('add-to-cart--loading');
//       }

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: qty })
//       })
//       .then(res => {
//         if (!res.ok) throw new Error('Cart add failed');
//         return res.json();
//       })
//       .then(function () {
//         // cart drawer open
//         const drawer = document.querySelector('cart-drawer-component');
//         if (drawer && typeof drawer.open === 'function') {
//           drawer.open();
//         }

//         // cart drawer price sync চালু করো
//         initCartDrawerPriceSync();

//         // header cart count update
//         fetch('/cart.js')
//           .then(r => r.json())
//           .then(function (cart) {
//             document.querySelectorAll('[data-cart-count]').forEach(el => {
//               el.textContent = cart.item_count;
//             });
//           });
//       })
//       .catch(function (err) {
//         console.error('Cart error:', err);
//         alert('Something went wrong. Please try again.');
//       })
//       .finally(function () {
//         if (cartBtn) {
//           cartBtn.disabled = false;
//           cartBtn.classList.remove('add-to-cart--loading');
//         }
//       });
//     });
//   }

//   // ── Gallery ──────────────────────────────────────────────────
//   const thumbBtns = document.querySelectorAll('.product-gallery__thumb');
//   const slides    = document.querySelectorAll('.product-gallery__slide');
//   const dots      = document.querySelectorAll('.product-gallery__dot');

//   function goToSlide(index) {
//     slides.forEach((s, i) => s.classList.toggle('product-gallery__slide--active', i === index));
//     thumbBtns.forEach((t, i) => {
//       t.classList.toggle('product-gallery__thumb--active', i === index);
//       t.setAttribute('aria-selected', i === index);
//     });
//     dots.forEach((d, i) => {
//       d.classList.toggle('product-gallery__dot--active', i === index);
//       d.setAttribute('aria-selected', i === index);
//     });
//   }

//   thumbBtns.forEach((btn, i) => btn.addEventListener('click', () => goToSlide(i)));
//   dots.forEach((dot, i)  => dot.addEventListener('click',  () => goToSlide(i)));

//   // ── Accordion ────────────────────────────────────────────────
//   document.querySelectorAll('.accordion__trigger').forEach(trigger => {
//     trigger.addEventListener('click', function () {
//       const item   = this.closest('.accordion__item');
//       const panel  = item.querySelector('.accordion__panel');
//       const isOpen = this.getAttribute('aria-expanded') === 'true';

//       document.querySelectorAll('.accordion__trigger').forEach(t => {
//         t.setAttribute('aria-expanded', 'false');
//         t.closest('.accordion__item').querySelector('.accordion__panel').style.maxHeight = null;
//       });

//       if (!isOpen) {
//         this.setAttribute('aria-expanded', 'true');
//         panel.style.maxHeight = panel.scrollHeight + 'px';
//       }
//     });
//   });

//   // ── Init ─────────────────────────────────────────────────────
//   initQuickSelectLabels();
//   updatePriceUI(1);
//   updateSliderFill();

// })();



// (function () {
//   if (window.__pgScriptInitialized) return;
//   window.__pgScriptInitialized = true;

//   // ─────────────────────────────────────────────
//   // PRICE SYSTEM
//   // ─────────────────────────────────────────────
//   const PRICE_TABLE = {
//     1: 19.99, 2: 18.99, 3: 18.04, 4: 17.14, 5: 16.28,
//     6: 15.47, 7: 14.69, 8: 13.96, 9: 13.26, 10: 11.94,
//     11: 11.34, 12: 10.77, 13: 10.23, 14: 9.72, 15: 9.24,
//     16: 8.77, 17: 8.34, 18: 7.92, 19: 7.52, 20: 6.99
//   };

//   const BASE_PRICE    = PRICE_TABLE[1];
//   const MAX_PRICE_QTY = 20; // price table-e shorboccho tier eita
//   const MAX_QTY       = 49; // overall max quantity (slider max er sathe match)

//   function getUnitPrice(qty) {
//     // 20 er upore gele 20 er price-i thakbe
//     return PRICE_TABLE[Math.min(qty, MAX_PRICE_QTY)];
//   }

//   function fmt(n) {
//     return '$' + n.toFixed(2);
//   }

//   function getSavePercent(qty) {
//     return (((BASE_PRICE - getUnitPrice(qty)) / BASE_PRICE) * 100).toFixed(2);
//   }

//   // ─────────────────────────────────────────────
//   // ELEMENTS
//   // ─────────────────────────────────────────────
//   const qtyInput       = document.getElementById('qty-input');
//   const qtySlider       = document.querySelector('.quantity-control__slider');
//   const qtyHidden       = document.getElementById('pg-qty-hidden');
//   const unitPriceEl     = document.getElementById('pgUnitPrice');
//   const totalPriceEl    = document.getElementById('pgTotalPrice');
//   const comparePriceEl  = document.getElementById('pgComparePrice');
//   const qsButtons       = document.querySelectorAll('.quickselect__option:not(.quickselect__option--contact)');

//   let currentQty = 1;

//   // ─────────────────────────────────────────────
//   // SLIDER FILL
//   // ─────────────────────────────────────────────
//   function updateSliderFill() {
//     if (!qtySlider) return;
//     const min     = parseInt(qtySlider.min, 10);
//     const max     = parseInt(qtySlider.max, 10);
//     const val     = parseInt(qtySlider.value, 10);
//     const percent = ((val - min) / (max - min)) * 100;
//     qtySlider.style.background =
//       'linear-gradient(to right, #ddcb9f 0%, #ddcb9f ' + percent + '%, #f9f5ef ' + percent + '%, #f9f5ef 100%)';
//   }

//   // ─────────────────────────────────────────────
//   // PRICE UPDATE
//   // ─────────────────────────────────────────────
//   function updatePriceUI(qty) {
//     currentQty = Math.max(1, Math.min(MAX_QTY, parseInt(qty) || 1));

//     if (qtyInput)  qtyInput.value  = currentQty;
//     if (qtyHidden) qtyHidden.value = currentQty;

//     if (qtySlider) {
//       qtySlider.value = currentQty;
//       updateSliderFill();
//     }

//     const unit         = getUnitPrice(currentQty);
//     const total        = unit * currentQty;
//     const compareTotal = BASE_PRICE * currentQty;

//     // main price box ekhon TOTAL dekhabe (unit na)
//     if (unitPriceEl)  unitPriceEl.textContent  = fmt(total);

//     // optional separate total element (jodi thake)
//     if (totalPriceEl) totalPriceEl.textContent = fmt(total);

//     // compare price (strikethrough original total)
//     if (comparePriceEl) {
//       if (compareTotal > total) {
//         comparePriceEl.textContent   = fmt(compareTotal);
//         comparePriceEl.style.display = '';
//       } else {
//         comparePriceEl.style.display = 'none';
//       }
//     }

//     // quick select active
//     qsButtons.forEach(function (btn) {
//       btn.classList.toggle(
//         'quickselect__option--active',
//         parseInt(btn.dataset.qty) === currentQty
//       );
//     });
//   }
//   // Expose globally so the homepage bundle section (or any other script)
//   // can trigger a price/qty update if it ever runs on the same page.
//   window.updatePriceUI = updatePriceUI;

//   // ─────────────────────────────────────────────
//   // QUICK SELECT LABELS (save % text)
//   // ─────────────────────────────────────────────
//   function initQuickSelectLabels() {
//     [5, 10, 20].forEach(function (qty) {
//       const el = document.getElementById('save-' + qty);
//       if (el) el.textContent = getSavePercent(qty) + '% Save';
//     });
//   }

//   // ─────────────────────────────────────────────
//   // QUICK SELECT + QTY CONTROLS
//   // ─────────────────────────────────────────────
//   qsButtons.forEach(function (btn) {
//     btn.addEventListener('click', function () { updatePriceUI(btn.dataset.qty); });
//   });

//   var contactBtn = document.querySelector('.quickselect__option--contact');
//   if (contactBtn) {
//     contactBtn.addEventListener('click', function () {
//       window.location.href = '/pages/contact';
//     });
//   }

//   var minusBtn = document.querySelector('.quantity-control__btn--minus');
//   var plusBtn  = document.querySelector('.quantity-control__btn--plus');
//   if (minusBtn) minusBtn.addEventListener('click', function () { updatePriceUI(currentQty - 1); });
//   if (plusBtn)  plusBtn.addEventListener('click',  function () { updatePriceUI(currentQty + 1); });
//   if (qtyInput)  qtyInput.addEventListener('input',  function () { updatePriceUI(this.value); });
//   if (qtySlider) qtySlider.addEventListener('input', function () { updatePriceUI(this.value); });

//   // ─────────────────────────────────────────────
//   // CART COUNT UPDATE
//   // ─────────────────────────────────────────────
//   function updateCartCount(count) {
//     // standard data attribute
//     document.querySelectorAll('[data-cart-count]').forEach(function (el) {
//       el.textContent = count;
//     });
//     // Horizon bubble badge — hidden when 0
//     document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
//       el.hidden = (count === 0);
//       el.querySelectorAll('[aria-hidden]').forEach(function (inner) {
//         inner.textContent = count;
//       });
//     });
//     // Dawn / Horizon uses a <span> inside the cart link with specific class
//     document.querySelectorAll('.cart-count').forEach(function (el) {
//       el.textContent = count;
//     });
//   }

//   // ─────────────────────────────────────────────
//   // OPEN CART DRAWER — multi-strategy
//   // ─────────────────────────────────────────────
//   function openCartDrawer() {
//     // Strategy 1: Horizon custom element method
//     var drawer = document.querySelector('cart-drawer');
//     if (drawer && typeof drawer.open === 'function') {
//       drawer.open();
//       return;
//     }

//     // Strategy 2: cart-drawer-component (some Horizon versions)
//     var drawerComponent = document.querySelector('cart-drawer-component');
//     if (drawerComponent && typeof drawerComponent.open === 'function') {
//       drawerComponent.open();
//       return;
//     }

//     // Strategy 3: click the cart icon to trigger Horizon's own handler
//     var cartBtn = document.querySelector('[data-drawer-trigger="cart"], .cart-drawer__toggle, #cart-icon-bubble');
//     if (cartBtn) {
//       cartBtn.click();
//       return;
//     }

//     // Strategy 4: dispatch the event Horizon listens for
//     document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
//     window.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
//   }

//   // ─────────────────────────────────────────────
//   // CART DRAWER PRICE SYNC
//   // (jodi customer drawer-er nijer qty input diye
//   // quantity change kore, price box-o update hobe)
//   // ─────────────────────────────────────────────
//   function initCartDrawerPriceSync() {
//     // Shopify standard cart:updated event
//     document.addEventListener('cart:updated', function (e) {
//       if (!e.detail || !e.detail.cart) return;
//       var items = e.detail.cart.items;
//       if (items && items.length > 0) {
//         updatePriceUI(items[0].quantity);
//       }
//     });

//     // cart drawer quantity input direct watch
//     document.addEventListener('change', function (e) {
//       var target = e.target;
//       if (
//         target.closest('cart-drawer-component, cart-drawer') &&
//         (target.name === 'updates[]' || target.type === 'number')
//       ) {
//         updatePriceUI(parseInt(target.value) || 1);
//       }
//     });
//   }

//   // ─────────────────────────────────────────────
//   // INJECT SECTION HTML
//   // Replaces the inner content of the matching
//   // element so the custom element shell stays in
//   // the DOM (Horizon's JS listeners stay attached)
//   // ─────────────────────────────────────────────
//   function injectSectionHtml(sectionHtml, sectionId) {
//     var parser = new DOMParser();
//     var doc    = parser.parseFromString(sectionHtml, 'text/html');

//     // Try to find the matching element by id or tag
//     var selectors = [
//       '#shopify-section-' + sectionId,
//       '[id="shopify-section-' + sectionId + '"]',
//       'cart-drawer',
//       'cart-drawer-component',
//       '#cart-drawer',
//       '.cart-drawer'
//     ];

//     var newEl = null;
//     var curEl = null;

//     for (var i = 0; i < selectors.length; i++) {
//       newEl = doc.querySelector(selectors[i]);
//       curEl = document.querySelector(selectors[i]);
//       if (newEl && curEl) break;
//     }

//     if (newEl && curEl) {
//       // Swap innerHTML so the live element stays in place
//       curEl.innerHTML = newEl.innerHTML;
//       // Copy across any updated attributes (e.g. aria-expanded)
//       Array.from(newEl.attributes).forEach(function (attr) {
//         curEl.setAttribute(attr.name, attr.value);
//       });
//       return true;
//     }
//     return false;
//   }

//   // ─────────────────────────────────────────────
//   // DISCOVER WHICH SECTION IDS EXIST
//   // Horizon wraps sections as #shopify-section-{id}
//   // We sniff the page to find what the cart drawer
//   // section is actually called.
//   // ─────────────────────────────────────────────
//   function detectCartSectionIds() {
//     var ids = [];
//     var candidates = [
//       'cart-drawer',
//       'cart-notification',
//       'cart-icon-bubble',
//       'mini-cart',
//       'cart-items',
//       'cart'
//     ];
//     candidates.forEach(function (id) {
//       if (document.getElementById('shopify-section-' + id)) {
//         ids.push(id);
//       }
//     });
//     // fallback: scrape any section containing cart-drawer element
//     if (ids.length === 0) {
//       var el = document.querySelector('cart-drawer, cart-drawer-component, .cart-drawer');
//       if (el) {
//         var wrapper = el.closest('[id^="shopify-section-"]');
//         if (wrapper) {
//           ids.push(wrapper.id.replace('shopify-section-', ''));
//         }
//       }
//     }
//     return ids;
//   }

//   // ─────────────────────────────────────────────
//   // ADD TO CART
//   // ─────────────────────────────────────────────
//   var form = document.getElementById('pg-product-form');

//   if (form) {
//     form.addEventListener('submit', function (e) {
//       e.preventDefault();

//       // ── Variant ID: prefer the dedicated hidden field
//       // (#pg-variant-id) — falls back to a form field named
//       // "id" if the hidden field isn't present on the page.
//       var variantEl = document.getElementById('pg-variant-id')
//                     || form.querySelector('[name="id"]');
//       var variantId = variantEl ? Number(variantEl.value) : null;

//       if (!variantId) {
//         console.error('[PG] Missing variant ID');
//         return;
//       }

//       var cartBtn = form.querySelector('.add-to-cart');
//       if (cartBtn) {
//         cartBtn.disabled = true;
//         cartBtn.classList.add('add-to-cart--loading', 'loading');
//       }

//       // Detect which section IDs are on the page right now
//       var sectionIds = detectCartSectionIds();

//       // Always include common Horizon section IDs as a safety net
//       var sectionsToRequest = Array.from(new Set(
//         sectionIds.concat(['cart-drawer', 'cart-icon-bubble', 'cart-notification'])
//       ));

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id:       variantId,
//           quantity: currentQty,
//           sections: sectionsToRequest
//         })
//       })
//       .then(function (res) {
//         if (!res.ok) throw new Error('Cart add failed: ' + res.status);
//         return res.json();
//       })
//       .then(function (data) {
//         var injected = false;

//         // ── Try injecting via sections response ──
//         if (data.sections && typeof data.sections === 'object') {
//           // Prioritise cart-drawer; try all returned sections
//           var order = ['cart-drawer', 'cart-notification', 'mini-cart', 'cart'];
//           var keys  = Object.keys(data.sections);

//           // Try priority order first, then any remaining key
//           var tryKeys = order.filter(function (k) { return data.sections[k]; })
//                              .concat(keys.filter(function (k) { return order.indexOf(k) === -1; }));

//           tryKeys.forEach(function (sectionId) {
//             if (!injected) {
//               injected = injectSectionHtml(data.sections[sectionId], sectionId);
//             }
//           });

//           // Update cart icon bubble if returned
//           if (data.sections['cart-icon-bubble']) {
//             var bubbleWrapper = document.getElementById('shopify-section-cart-icon-bubble');
//             if (bubbleWrapper) {
//               var parser2    = new DOMParser();
//               var doc2       = parser2.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
//               var newBubble  = doc2.getElementById('shopify-section-cart-icon-bubble');
//               if (newBubble) bubbleWrapper.innerHTML = newBubble.innerHTML;
//             }
//           }
//         }

//         // ── Fallback: if sections injection didn't work,
//         //    fetch the cart-drawer section directly ──
//         if (!injected) {
//           console.warn('[PG] Sections injection missed — fetching cart drawer directly');
//           return fetch('/?section_id=cart-drawer')
//             .then(function (r) { return r.text(); })
//             .then(function (html) {
//               injectSectionHtml(html, 'cart-drawer');
//             });
//         }
//       })
//       .then(function () {
//         // ── Update cart count badge ──
//         return fetch('/cart.js').then(function (r) { return r.json(); });
//       })
//       .then(function (cart) {
//         updateCartCount(cart.item_count);
//         // cart drawer price sync চালু করো (drawer-er নিজের qty change track korte)
//         initCartDrawerPriceSync();
//         // Small tick to let DOM settle, then open drawer
//         setTimeout(openCartDrawer, 50);
//       })
//       .catch(function (err) {
//         console.error('[PG] Cart error:', err);
//         alert('Something went wrong adding to cart. Please try again.');
//       })
//       .finally(function () {
//         if (cartBtn) {
//           cartBtn.disabled = false;
//           cartBtn.classList.remove('add-to-cart--loading', 'loading');
//         }
//       });
//     });
//   }

//   // ─────────────────────────────────────────────
//   // GALLERY
//   // ─────────────────────────────────────────────
//   var thumbBtns = document.querySelectorAll('.product-gallery__thumb');
//   var slides    = document.querySelectorAll('.product-gallery__slide');
//   var dots      = document.querySelectorAll('.product-gallery__dot');

//   function goToSlide(index) {
//     slides.forEach(function (s, i) {
//       s.classList.toggle('product-gallery__slide--active', i === index);
//     });
//     thumbBtns.forEach(function (t, i) {
//       t.classList.toggle('product-gallery__thumb--active', i === index);
//       t.setAttribute('aria-selected', i === index);
//     });
//     dots.forEach(function (d, i) {
//       d.classList.toggle('product-gallery__dot--active', i === index);
//       d.setAttribute('aria-selected', i === index);
//     });
//   }

//   thumbBtns.forEach(function (btn, i) {
//     btn.addEventListener('click', function () { goToSlide(i); });
//   });
//   dots.forEach(function (dot, i) {
//     dot.addEventListener('click', function () { goToSlide(i); });
//   });

//   // ─────────────────────────────────────────────
//   // ACCORDION
//   // ─────────────────────────────────────────────
//   document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
//     trigger.addEventListener('click', function () {
//       var item   = this.closest('.accordion__item');
//       var panel  = item.querySelector('.accordion__panel');
//       var isOpen = this.getAttribute('aria-expanded') === 'true';

//       document.querySelectorAll('.accordion__trigger').forEach(function (t) {
//         t.setAttribute('aria-expanded', 'false');
//         var p = t.closest('.accordion__item').querySelector('.accordion__panel');
//         if (p) p.style.maxHeight = null;
//       });

//       if (!isOpen) {
//         this.setAttribute('aria-expanded', 'true');
//         panel.style.maxHeight = panel.scrollHeight + 'px';
//       }
//     });
//   });

//   // ─────────────────────────────────────────────
//   // INIT
//   // URL এ ?quantity=10 থাকলে সেটা পড়ে নিয়ে
//   // qty box + slider + Quick Select highlight +
//   // price — সব অটোমেটিক সেই কোয়ান্টিটি অনুযায়ী
//   // সেট হয়ে যাবে (হোমপেজ থেকে আসা redirect এর জন্য)
//   // ─────────────────────────────────────────────
//   function getInitialQty() {
//     var params = new URLSearchParams(window.location.search);
//     var q = parseInt(params.get('quantity'), 10);
//     if (q && q > 0) return q;
//     return 1;
//   }

//   initQuickSelectLabels();
//   updatePriceUI(getInitialQty());
//   updateSliderFill();

// })();




(function () {
  if (window.__pgScriptInitialized) return;
  window.__pgScriptInitialized = true;

  // ─────────────────────────────────────────────
  // PRICE SYSTEM
  // ─────────────────────────────────────────────
  // Every quantity (1–50 Hangers) is now its own real Shopify
  // variant with its own real price (set in Admin to match the
  // client's price list exactly). So there is no calculation here
  // at all — picking a quantity just looks up that exact variant's
  // real id + real price from #pg-variant-map (rendered by Liquid
  // from product.variants). Whatever shows on the page IS the
  // variant that gets added to the cart, so display price and cart
  // price can never diverge.
  const MAX_QTY = 50; // matches the highest "N Hangers" variant

  function fmt(n) {
    return '$' + n.toFixed(2);
  }

  function readVariantMap() {
    const el = document.getElementById('pg-variant-map');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (err) {
      console.error('[PG] Could not parse variant map:', err);
      return {};
    }
  }

  const VARIANT_MAP = readVariantMap(); // { "1": {id, price}, "2": {...}, ..., "50": {...} }

  // ─────────────────────────────────────────────
  // ELEMENTS
  // ─────────────────────────────────────────────
  const qtyInput        = document.getElementById('qty-input');
  const qtySlider        = document.querySelector('.quantity-control__slider');
  const qtyHidden        = document.getElementById('pg-qty-hidden');
  const unitPriceEl      = document.getElementById('pgUnitPrice');
  const totalPriceEl     = document.getElementById('pgTotalPrice');
  const comparePriceEl   = document.getElementById('pgComparePrice');
  const qsButtons        = document.querySelectorAll('.quickselect__option:not(.quickselect__option--contact)');
  const variantHiddenEl  = document.getElementById('pg-variant-id');

  // Base = the "1 Hanger" variant's real price. Used only as the
  // reference point for the strikethrough "compare at" price
  // (what it would cost to buy N single hangers at full price).
  const BASE_PRICE = VARIANT_MAP['1'] ? parseFloat(VARIANT_MAP['1'].price) || 0 : 0;

  let currentQty = 1;

  // ─────────────────────────────────────────────
  // SLIDER FILL
  // ─────────────────────────────────────────────
  function updateSliderFill() {
    if (!qtySlider) return;
    const min     = parseInt(qtySlider.min, 10);
    const max     = parseInt(qtySlider.max, 10);
    const val     = parseInt(qtySlider.value, 10);
    const percent = ((val - min) / (max - min)) * 100;
    qtySlider.style.background =
      'linear-gradient(to right, #B8922A 0%, #B8922A ' + percent + '%, #f9f5ef ' + percent + '%, #f9f5ef 100%)';
  }

  // ─────────────────────────────────────────────
  // PRICE UPDATE
  // ─────────────────────────────────────────────
  // qty here means "which N-Hangers variant is selected", not a
  // multiplier. We look it up directly — no math on our end. The
  // cart line quantity always stays 1, since one variant already
  // represents the full bundle of N hangers.
  function updatePriceUI(qty) {
    currentQty = Math.max(1, Math.min(MAX_QTY, parseInt(qty) || 1));

    const entry = VARIANT_MAP[String(currentQty)];
    if (!entry) {
      console.warn('[PG] No variant found for quantity', currentQty);
      return;
    }

    if (qtyInput)  qtyInput.value  = currentQty;
    if (qtyHidden) qtyHidden.value = 1; // one line item of the selected N-Hangers variant
    if (variantHiddenEl) variantHiddenEl.value = entry.id;

    if (qtySlider) {
      qtySlider.value = currentQty;
      updateSliderFill();
    }

    const total        = parseFloat(entry.price) || 0;
    const compareTotal = BASE_PRICE * currentQty;

    if (unitPriceEl)  unitPriceEl.textContent  = fmt(total);
    if (totalPriceEl) totalPriceEl.textContent = fmt(total);

    if (comparePriceEl) {
      if (compareTotal > total) {
        comparePriceEl.textContent   = fmt(compareTotal);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // quick select active state
    qsButtons.forEach(function (btn) {
      btn.classList.toggle(
        'quickselect__option--active',
        parseInt(btn.dataset.qty, 10) === currentQty
      );
    });
  }
  // Expose globally so the homepage bundle section (or any other script)
  // can trigger a price/qty update if it ever runs on the same page.
  window.updatePriceUI = updatePriceUI;

  // ─────────────────────────────────────────────
  // QUICK SELECT LABELS (save % text)
  // ─────────────────────────────────────────────
  // Computed from real variant prices (N-Hangers variant vs. base ×
  // N), not a hardcoded table — stays correct automatically if
  // prices ever change in Shopify Admin.
  function initQuickSelectLabels() {
    qsButtons.forEach(function (btn) {
      const qtyLabel = parseInt(btn.dataset.qty, 10);
      const entry    = VARIANT_MAP[String(qtyLabel)];
      if (!qtyLabel || !entry || !BASE_PRICE) return;

      const price         = parseFloat(entry.price) || 0;
      const compareTotal  = BASE_PRICE * qtyLabel;
      const pct = compareTotal > price
        ? (((compareTotal - price) / compareTotal) * 100).toFixed(0)
        : 0;

      const el = document.getElementById('save-' + qtyLabel);
      if (el) el.textContent = pct + '% Save';
    });
  }

  // ─────────────────────────────────────────────
  // QUICK SELECT + QTY CONTROLS
  // ─────────────────────────────────────────────
  qsButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      updatePriceUI(btn.dataset.qty);
    });
  });

  var contactBtn = document.querySelector('.quickselect__option--contact');
  if (contactBtn) {
    contactBtn.addEventListener('click', function () {
      window.location.href = '/pages/contact';
    });
  }

  var minusBtn = document.querySelector('.quantity-control__btn--minus');
  var plusBtn  = document.querySelector('.quantity-control__btn--plus');
  if (minusBtn) minusBtn.addEventListener('click', function () { updatePriceUI(currentQty - 1); });
  if (plusBtn)  plusBtn.addEventListener('click',  function () { updatePriceUI(currentQty + 1); });
  if (qtyInput)  qtyInput.addEventListener('input',  function () { updatePriceUI(this.value); });
  if (qtySlider) qtySlider.addEventListener('input', function () { updatePriceUI(this.value); });

  // ─────────────────────────────────────────────
  // CART COUNT UPDATE
  // ─────────────────────────────────────────────
  function updateCartCount(count) {
    // standard data attribute
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    // Horizon bubble badge — hidden when 0
    document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
      el.hidden = (count === 0);
      el.querySelectorAll('[aria-hidden]').forEach(function (inner) {
        inner.textContent = count;
      });
    });
    // Dawn / Horizon uses a <span> inside the cart link with specific class
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  // ─────────────────────────────────────────────
  // OPEN CART DRAWER — multi-strategy
  // ─────────────────────────────────────────────
  function openCartDrawer() {
    // Strategy 1: Horizon custom element method
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    // Strategy 2: cart-drawer-component (some Horizon versions)
    var drawerComponent = document.querySelector('cart-drawer-component');
    if (drawerComponent && typeof drawerComponent.open === 'function') {
      drawerComponent.open();
      return;
    }

    // Strategy 3: click the cart icon to trigger Horizon's own handler
    var cartBtn = document.querySelector('[data-drawer-trigger="cart"], .cart-drawer__toggle, #cart-icon-bubble');
    if (cartBtn) {
      cartBtn.click();
      return;
    }

    // Strategy 4: dispatch the event Horizon listens for
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    window.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  // ─────────────────────────────────────────────
  // CART DRAWER PRICE SYNC
  // (jodi customer drawer-er nijer qty input diye
  // quantity change kore, price box-o update hobe)
  // ─────────────────────────────────────────────
  function initCartDrawerPriceSync() {
    // Shopify standard cart:updated event
    document.addEventListener('cart:updated', function (e) {
      if (!e.detail || !e.detail.cart) return;
      var items = e.detail.cart.items;
      if (items && items.length > 0) {
        updatePriceUI(items[0].quantity);
      }
    });

    // cart drawer quantity input direct watch
    document.addEventListener('change', function (e) {
      var target = e.target;
      if (
        target.closest('cart-drawer-component, cart-drawer') &&
        (target.name === 'updates[]' || target.type === 'number')
      ) {
        updatePriceUI(parseInt(target.value) || 1);
      }
    });
  }

  // ─────────────────────────────────────────────
  // INJECT SECTION HTML
  // Replaces the inner content of the matching
  // element so the custom element shell stays in
  // the DOM (Horizon's JS listeners stay attached)
  // ─────────────────────────────────────────────
  function injectSectionHtml(sectionHtml, sectionId) {
    var parser = new DOMParser();
    var doc    = parser.parseFromString(sectionHtml, 'text/html');

    // Try to find the matching element by id or tag
    var selectors = [
      '#shopify-section-' + sectionId,
      '[id="shopify-section-' + sectionId + '"]',
      'cart-drawer',
      'cart-drawer-component',
      '#cart-drawer',
      '.cart-drawer'
    ];

    var newEl = null;
    var curEl = null;

    for (var i = 0; i < selectors.length; i++) {
      newEl = doc.querySelector(selectors[i]);
      curEl = document.querySelector(selectors[i]);
      if (newEl && curEl) break;
    }

    if (newEl && curEl) {
      // Swap innerHTML so the live element stays in place
      curEl.innerHTML = newEl.innerHTML;
      // Copy across any updated attributes (e.g. aria-expanded)
      Array.from(newEl.attributes).forEach(function (attr) {
        curEl.setAttribute(attr.name, attr.value);
      });
      return true;
    }
    return false;
  }

  // ─────────────────────────────────────────────
  // DISCOVER WHICH SECTION IDS EXIST
  // Horizon wraps sections as #shopify-section-{id}
  // We sniff the page to find what the cart drawer
  // section is actually called.
  // ─────────────────────────────────────────────
  function detectCartSectionIds() {
    var ids = [];
    var candidates = [
      'cart-drawer',
      'cart-notification',
      'cart-icon-bubble',
      'mini-cart',
      'cart-items',
      'cart'
    ];
    candidates.forEach(function (id) {
      if (document.getElementById('shopify-section-' + id)) {
        ids.push(id);
      }
    });
    // fallback: scrape any section containing cart-drawer element
    if (ids.length === 0) {
      var el = document.querySelector('cart-drawer, cart-drawer-component, .cart-drawer');
      if (el) {
        var wrapper = el.closest('[id^="shopify-section-"]');
        if (wrapper) {
          ids.push(wrapper.id.replace('shopify-section-', ''));
        }
      }
    }
    return ids;
  }

  // ─────────────────────────────────────────────
  // ADD TO CART
  // ─────────────────────────────────────────────
  var form = document.getElementById('pg-product-form');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // ── Variant ID: prefer the dedicated hidden field
      // (#pg-variant-id) — falls back to a form field named
      // "id" if the hidden field isn't present on the page.
      var variantEl = document.getElementById('pg-variant-id')
                    || form.querySelector('[name="id"]');
      var variantId = variantEl ? Number(variantEl.value) : null;

      if (!variantId) {
        console.error('[PG] Missing variant ID');
        return;
      }

      var cartBtn = form.querySelector('.add-to-cart');
      if (cartBtn) {
        cartBtn.disabled = true;
        cartBtn.classList.add('add-to-cart--loading', 'loading');
      }

      // Detect which section IDs are on the page right now
      var sectionIds = detectCartSectionIds();

      // Always include common Horizon section IDs as a safety net
      var sectionsToRequest = Array.from(new Set(
        sectionIds.concat(['cart-drawer', 'cart-icon-bubble', 'cart-notification'])
      ));

      // Cart line quantity is always 1 here — currentQty is which
      // "N Hangers" variant is selected, not a multiplier. The
      // variant itself already represents the full bundle of N
      // hangers, so quantity 1 of that variant = N hangers.
      var cartLineQty = qtyHidden ? (parseInt(qtyHidden.value, 10) || 1) : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id:       variantId,
          quantity: cartLineQty,
          sections: sectionsToRequest
        })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var injected = false;

        // ── Try injecting via sections response ──
        if (data.sections && typeof data.sections === 'object') {
          // Prioritise cart-drawer; try all returned sections
          var order = ['cart-drawer', 'cart-notification', 'mini-cart', 'cart'];
          var keys  = Object.keys(data.sections);

          // Try priority order first, then any remaining key
          var tryKeys = order.filter(function (k) { return data.sections[k]; })
                             .concat(keys.filter(function (k) { return order.indexOf(k) === -1; }));

          tryKeys.forEach(function (sectionId) {
            if (!injected) {
              injected = injectSectionHtml(data.sections[sectionId], sectionId);
            }
          });

          // Update cart icon bubble if returned
          if (data.sections['cart-icon-bubble']) {
            var bubbleWrapper = document.getElementById('shopify-section-cart-icon-bubble');
            if (bubbleWrapper) {
              var parser2    = new DOMParser();
              var doc2       = parser2.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              var newBubble  = doc2.getElementById('shopify-section-cart-icon-bubble');
              if (newBubble) bubbleWrapper.innerHTML = newBubble.innerHTML;
            }
          }
        }

        // ── Fallback: if sections injection didn't work,
        //    fetch the cart-drawer section directly ──
        if (!injected) {
          console.warn('[PG] Sections injection missed — fetching cart drawer directly');
          return fetch('/?section_id=cart-drawer')
            .then(function (r) { return r.text(); })
            .then(function (html) {
              injectSectionHtml(html, 'cart-drawer');
            });
        }
      })
      .then(function () {
        // ── Update cart count badge ──
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        // cart drawer price sync চালু করো (drawer-er নিজের qty change track korte)
        initCartDrawerPriceSync();
        // Small tick to let DOM settle, then open drawer
        setTimeout(openCartDrawer, 50);
      })
      .catch(function (err) {
        console.error('[PG] Cart error:', err);
        alert('Something went wrong adding to cart. Please try again.');
      })
      .finally(function () {
        if (cartBtn) {
          cartBtn.disabled = false;
          cartBtn.classList.remove('add-to-cart--loading', 'loading');
        }
      });
    });
  }

  // ─────────────────────────────────────────────
  // GALLERY
  // ─────────────────────────────────────────────
  var thumbBtns = document.querySelectorAll('.product-gallery__thumb');
  var slides    = document.querySelectorAll('.product-gallery__slide');
  var dots      = document.querySelectorAll('.product-gallery__dot');

  function goToSlide(index) {
    slides.forEach(function (s, i) {
      s.classList.toggle('product-gallery__slide--active', i === index);
    });
    thumbBtns.forEach(function (t, i) {
      t.classList.toggle('product-gallery__thumb--active', i === index);
      t.setAttribute('aria-selected', i === index);
    });
    dots.forEach(function (d, i) {
      d.classList.toggle('product-gallery__dot--active', i === index);
      d.setAttribute('aria-selected', i === index);
    });
  }

  thumbBtns.forEach(function (btn, i) {
    btn.addEventListener('click', function () { goToSlide(i); });
  });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goToSlide(i); });
  });

  // ─────────────────────────────────────────────
  // ACCORDION
  // ─────────────────────────────────────────────
  document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item   = this.closest('.accordion__item');
      var panel  = item.querySelector('.accordion__panel');
      var isOpen = this.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.accordion__trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var p = t.closest('.accordion__item').querySelector('.accordion__panel');
        if (p) p.style.maxHeight = null;
      });

      if (!isOpen) {
        this.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  // ─────────────────────────────────────────────
  // ─────────────────────────────────────────────
  function getInitialQty() {
    var params = new URLSearchParams(window.location.search);
    var q = parseInt(params.get('quantity'), 10);
    if (q && q > 0) return q;
    return 1;
  }

  initQuickSelectLabels();
  updatePriceUI(getInitialQty());
  updateSliderFill();

})();
